import "./UpdateStatusModal.css";

import { ProjectStatusConstants } from "../../../../constants";
import { Button, Column, ErrorBox, InformationBox, Modal, Row, Select } from "../../../../widget";
import { useUpdateStatusModal } from "./useUpdateStatusModal";

interface UpdateStatusModalProps {
  existingStatus: string;
  isGroupProject: boolean;
  showUpdateStatusModal: boolean;
  closeModal: () => void;
}

export const UpdateStatusModal = ({
  existingStatus,
  isGroupProject,
  showUpdateStatusModal,
  closeModal,
}: UpdateStatusModalProps): JSX.Element => {
  const {
    errors,
    isHandleSubmitLoading,
    isStatusOptionsLoading,
    selectedStatus,
    statusOptions,
    setSelectedStatus,
    resetForm,
    handleSubmit,
  } = useUpdateStatusModal({
    closeModal,
    existingStatus,
  });
  const handleClose = (): void => {
    resetForm();
    closeModal();
  };

  return (
    <Modal show={showUpdateStatusModal} title="Update status" className="UpdateStatusModal" onClose={handleClose}>
      <form onSubmit={(e) => handleSubmit(e)} className="UpdateStatusModalContent">
        {errors && errors.length > 0 && (
          <Row spacingV="ml" justify="center">
            <Column span={6}>
              <ErrorBox
                title="Please solve the below issues before saving"
                text={errors.map((error) => error.message)}
              />
            </Column>
          </Row>
        )}
        <Row spacingV="2xl" justify="center">
          <Column span={12}>
            <p className="body2 UpdateStatusModalIntro">
              Select the registry status you would like to change this project to. Please note, this will not change the
              status on the project&apos;s external registry.
            </p>
            {isGroupProject && (
              <InformationBox variant="alert" title="This project is in a registry group">
                <p className="body2">
                  Since this project is in a registry group, updating the status for this project will update the status
                  for all projects in the registry group.
                </p>
              </InformationBox>
            )}
          </Column>
        </Row>
        <Row justify="center">
          <Column span={12}>
            <div className="UpdateStatusModalSelectWrapper">
              <Select
                label={ProjectStatusConstants.REGISTRY_STATUS_LABEL}
                placeholder={isStatusOptionsLoading ? "Loading" : "Select"}
                data={statusOptions}
                value={selectedStatus}
                onChange={setSelectedStatus}
                disabled={isStatusOptionsLoading || statusOptions.length === 0}
                corners="rounded"
                className="UpdateStatusModalSelect"
              />
            </div>
          </Column>
        </Row>
        <Row justify="center">
          <Column span={12}>
            <div className="UpdateStatusModalActions">
              <Button
                text="Confirm"
                type="submit"
                isLoading={isHandleSubmitLoading}
                disabled={!selectedStatus || isStatusOptionsLoading}
                corners="rounded"
                className="UpdateStatusModalConfirmButton"
              />
              <Button
                text="Cancel"
                variant="secondary"
                onClick={handleClose}
                corners="rounded"
                className="UpdateStatusModalCancelButton"
              />
            </div>
          </Column>
        </Row>
      </form>
    </Modal>
  );
};
